// extracted by mini-css-extract-plugin
module.exports = {"indicator":"ActivityIndicator_indicator__1szwG","spin":"ActivityIndicator_spin__1udB4","light":"ActivityIndicator_light__WrG5I","large":"ActivityIndicator_large__23aHT"};